import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

import { getUserProfile } from '../../api/user-profile/getUserProfile';
import { useApp } from '../../hooks/useApp';
import { AsyncState, useAsync } from '../../hooks/useAsync';

const UserProfileContext = createContext<UserProfileContextProps>({});

export type UserProfileContextProps = { userData?: SimpleProjectServiceAPI.UserDto };

export const UserProfileContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [userData, setUserData] = useState<SimpleProjectServiceAPI.UserDto | null>(null);
  const { loggedIn } = useApp();

  const { start: fetchProfile, result: userProfile, state: fetchProfileState } = useAsync(
    getUserProfile,
  );

  useEffect(() => {
    if (loggedIn) {
      fetchProfile();
    }
  }, [loggedIn, fetchProfile]);

  useEffect(() => {
    if (fetchProfileState === AsyncState.Finished && !(userProfile instanceof Error)) {
      setUserData(userProfile);
    }
  }, [fetchProfileState, userProfile]);

  return <UserProfileContext.Provider value={{ userData }}>{children}</UserProfileContext.Provider>;
};

export const useUserProfile = () => useContext(UserProfileContext);
